module.exports = __webpack_public_path__ + "static/media/tlyfeBig.f026e1fe.png";